import { styled } from '@mui/system'

export const FlexWrapper = styled('div')({
  display: 'flex'
})

export const AlignCenterWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center'
})

export const ContentCenteredWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

export const TableWrapper = styled('div')({
  display: 'flex',
  overflow: 'auto',
  scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.65em'
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#c3c2c2'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#888'
  },
  paddingBottom: '.75rem'
})

export const FormWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  padding: '0rem 2rem'
})
